<template>
  <v-container fluid class="pa-0">
    <!-- CABECERA ESTILO PBXBERRY (TABS DE TIEMPO) -->
    <v-card color="secondary" dark flat tile>
      <v-tabs v-model="timeTab" background-color="transparent" centered slider-color="white" @change="onTimeTabChange">
        <v-tab v-for="item in timeOptions" :key="item">{{ item }}</v-tab>
      </v-tabs>
    </v-card>

    <!-- BARRA DE FILTRO PERSONALIZADO (Solo se ve si elige PERSONALIZADO) -->
    <v-expand-transition>
      <v-card v-if="timeTab === 3" class="ma-4 pa-2" outlined>
        <v-row dense align="center" justify="center">
          <v-col cols="12" md="3">
            <v-text-field type="date" v-model="filters.start" label="Desde" dense outlined hide-details></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field type="date" v-model="filters.end" label="Hasta" dense outlined hide-details></v-text-field>
          </v-col>
          <v-col cols="12" md="1">
            <v-btn color="secondary" fab x-small @click="fetchData"><v-icon>mdi-magnify</v-icon></v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-expand-transition>

    <!-- CUERPO DEL REPORTE -->
    <v-row class="ma-4">
      <!-- COLUMNA IZQUIERDA: MÉTRICAS (Tabla) -->
      <v-col cols="12" md="5">
        <v-card outlined height="100%">
          <v-simple-table dense>
            <thead>
              <tr class="grey lighten-4">
                <th class="text-left font-weight-bold">Nombre</th>
                <th class="text-right font-weight-bold">Valor</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Total citas</td>
                <td class="text-right font-weight-bold">{{ totals.total }}</td>
              </tr>
              <tr>
                <td>Citas confirmadas</td>
                <td class="text-right font-weight-bold">
                  {{ totals.confirmed }} <span class="caption grey--text">({{ totals.confirmedPerc }}%)</span>
                </td>
              </tr>
              <tr>
                <td>Citas pendientes</td>
                <td class="text-right font-weight-bold">
                  {{ totals.pending }} <span class="caption grey--text">({{ totals.pendingPerc }}%)</span>
                </td>
              </tr>
              <tr>
                <td>Citas canceladas</td>
                <td class="text-right font-weight-bold">
                  {{ totals.canceled }} <span class="caption grey--text">({{ totals.canceledPerc }}%)</span>
                </td>
              </tr>
              <tr class="blue lighten-5">
                <td class="primary--text font-weight-bold">
                  Efectividad global
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" x-small color="primary" class="ml-1">mdi-information</v-icon>
                    </template>
                    <span>(Confirmadas + Canceladas) / Total</span>
                  </v-tooltip>
                </td>
                <td class="text-right primary--text font-weight-bold">{{ totals.effectivenessPerc }} %</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card>
      </v-col>

      <!-- COLUMNA DERECHA: GRÁFICOS CON TABS INTERNOS -->
      <v-col cols="12" md="7">
        <v-card outlined height="100%">
          <v-tabs v-model="chartTab" color="secondary" dense>
            <v-tab small>Atención (Estados)</v-tab>
            <v-tab small>Histórico</v-tab>
          </v-tabs>
          <v-divider></v-divider>

          <v-card-text>
            <v-tabs-items v-model="chartTab">
              <!-- TAB DONA -->
              <v-tab-item>
                <div v-if="loading" class="text-center pa-10"><v-progress-circular indeterminate color="secondary"></v-progress-circular></div>
                <apexchart v-else type="donut" height="400" :options="donutOptions" :series="donutSeries"></apexchart>
              </v-tab-item>

              <!-- TAB BARRAS -->
              <v-tab-item>
                <div v-if="loading" class="text-center pa-10"><v-progress-circular indeterminate color="secondary"></v-progress-circular></div>
                <apexchart v-else type="bar" height="400" :options="barOptions" :series="barSeries"></apexchart>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  data: () => ({
    loading: false,
    timeTab: 0,
    chartTab: 0,
    timeOptions: ["DÍA", "MES", "AÑO", "PERSONALIZADO"],
    filters: {
      start: moment().format('YYYY-MM-DD'),
      end: moment().format('YYYY-MM-DD'),
    },
    rawDays: [],
    totals: { 
      total: 0, 
      confirmed: 0, 
      pending: 0, 
      canceled: 0, 
      confirmedPerc: 0, 
      pendingPerc: 0, 
      canceledPerc: 0,
      effectivenessPerc: 0 
    },
    donutOptions: {
      labels: ['Confirmadas', 'Pendientes', 'Canceladas'],
      colors: ['#00E676', '#2979FF', '#FF9100'],
      legend: { position: 'right', verticalAlign: 'middle' },
      plotOptions: { pie: { donut: { labels: { show: true, total: { show: true, label: 'TOTAL' } } } } }
    },
    barOptions: {
      chart: {
        id: 'history-chart',
        stacked: true,
        toolbar: { show: false },
        zoom: { enabled: false }
      },
      plotOptions: {
        bar: { borderRadius: 2, columnWidth: '70%' }
      },
      colors: ['#00E676', '#2979FF', '#FF9100'],
      xaxis: {
        categories: [],
        type: 'category',
        labels: { rotate: -45, style: { fontSize: '10px' } }
      },
      legend: { position: 'bottom' },
      dataLabels: { enabled: false },
      tooltip: {
        shared: true,
        intersect: false,
        followCursor: true,
        theme: 'light',
        x: { show: true },
        y: {
          formatter: function (val, { seriesIndex, dataPointIndex, w }) {
            const total = w.globals.stackedSeriesTotals[dataPointIndex];
            const percent = total > 0 ? ((val / total) * 100).toFixed(1) : 0;
            return val + " (" + percent + "%)";
          },
        },
      },
    },
    barSeries: []
  }),

  computed: {
    clientId() {
      const userData = localStorage.getItem("user");
      return userData ? JSON.parse(userData).client_id : '107';
    },
    donutSeries() { return [this.totals.confirmed, this.totals.pending, this.totals.canceled]; }
  },

  methods: {
    onTimeTabChange(val) {
      if (val === 0) {
        this.filters.start = moment().format('YYYY-MM-DD');
        this.filters.end = moment().format('YYYY-MM-DD');
      } else if (val === 1) {
        this.filters.start = moment().startOf('month').format('YYYY-MM-DD');
        this.filters.end = moment().endOf('month').format('YYYY-MM-DD');
      } else if (val === 2) {
        this.filters.start = moment().startOf('year').format('YYYY-MM-DD');
        this.filters.end = moment().endOf('year').format('YYYY-MM-DD');
      }
      if (val !== 3) this.fetchData();
    },

    async fetchData() {
      this.loading = true;
      try {
        const response = await axios.get('https://c103.pbxberry.com:486/api/reporte_confirmacion2', {
          params: { action: 'query2', client_id: this.clientId, start: this.filters.start, end: this.filters.end }
        });

        if (response.data.ok) {
          const rawData = response.data.days;
          this.rawDays = rawData;

          let categories = [];
          let seriesData = { confirmed: [], pending: [], canceled: [] };

          if (this.timeTab === 2) {
            const grouped = {};
            rawData.forEach(day => {
              const monthName = moment(day.fecha).format('MMM YYYY');
              if (!grouped[monthName]) grouped[monthName] = { c: 0, p: 0, ca: 0 };
              grouped[monthName].c += day.confirmed;
              grouped[monthName].p += day.pending;
              grouped[monthName].ca += day.canceled;
            });
            categories = Object.keys(grouped);
            seriesData.confirmed = Object.values(grouped).map(m => m.c);
            seriesData.pending = Object.values(grouped).map(m => m.p);
            seriesData.canceled = Object.values(grouped).map(m => m.ca);
          } else {
            categories = rawData.map(d => d.fecha);
            seriesData.confirmed = rawData.map(d => d.confirmed);
            seriesData.pending = rawData.map(d => d.pending);
            seriesData.canceled = rawData.map(d => d.canceled);
          }

          this.barOptions = { ...this.barOptions, xaxis: { ...this.barOptions.xaxis, categories: categories } };
          this.barSeries = [
            { name: 'Confirmadas', data: seriesData.confirmed },
            { name: 'Pendientes', data: seriesData.pending },
            { name: 'Canceladas', data: seriesData.canceled }
          ];

          this.calculateTotals();
        }
      } catch (error) { console.error(error); } finally { this.loading = false; }
    },

    calculateTotals() {
      const t = { 
        total: 0, confirmed: 0, pending: 0, canceled: 0, 
        confirmedPerc: 0, pendingPerc: 0, canceledPerc: 0,
        effectivenessPerc: 0 
      };
      
      this.rawDays.forEach(d => {
        t.confirmed += d.confirmed;
        t.pending += d.pending;
        t.canceled += d.canceled;
      });
      
      t.total = t.confirmed + t.pending + t.canceled;

      if (t.total > 0) {
        // Porcentajes individuales para las filas de la tabla
        t.confirmedPerc = ((t.confirmed / t.total) * 100).toFixed(1);
        t.pendingPerc = ((t.pending / t.total) * 100).toFixed(1);
        t.canceledPerc = ((t.canceled / t.total) * 100).toFixed(1);

        // FÓRMULA SOLICITADA: (Confirmadas + Canceladas) / Total
        t.effectivenessPerc = (((t.confirmed + t.canceled) / t.total) * 100).toFixed(1);
      }
      this.totals = t;
    }
  },

  mounted() { this.fetchData(); }
};
</script>

<style scoped>
.v-data-table >>> td {
  height: 45px !important;
  font-size: 0.85rem !important;
  border-bottom: 1px solid #f0f0f0 !important;
}
</style>
